import {useCallback} from 'react';
import {AXIOS} from "../../../services/api";

export const useHandleSubscription = (activePlanId) => {
	return useCallback(
		async (planId) => {
			if (activePlanId === planId) {
				return {success: false, message: "This is already your current plan."};
			}

			try {
				const response = await AXIOS.post(`/subscription/checkout/${planId}`);
				if (response.status >= 200 && response.status < 300) {
					return {success: true, url: response.data.url};
				} else {
					return {success: false, message: "An unexpected issue occurred. Please try again."};
				}
			} catch (error) {
				let message = "An error occurred during checkout. Please check your connection and try again.";

				if (error.response) {
					switch (error.response.status) {
						case 422:
							message = "Unable to process payment. Please try again later.";
							break;
						case 409:
							message = "You already have an active subscription.";
							break;
						case 401:
							message = "Authentication required. Please log in again.";
							break;
						default:
							break;
					}
				} else if (error.request) {
					message = "Network error. Please check your connection and try again.";
				}

				return {success: false, message};
			}
		},
		[activePlanId]
	);
};
